
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/covid-19",
      function () {
        return require("private-next-pages/support/covid-19.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/covid-19"])
      });
    }
  